<template>
  <div v-if="JtDataTable.buttonsTop.length > 0" class="buttons-top q-px-md q-pb-md q-gutter-sm full-width text-right">
    <span v-for="(button, index) in filterButtons(JtDataTable.buttonsTop)" :key="index" :class="button.name"  >
      <billing-order-dropdown-new-button v-if="index == 0" label="Novo" :buttons="filterButtonsNew(JtDataTable.buttonsTop)" class="dropdown-button margin-top"
      @action-button="(b) => {$emit('action-button', b, {}, this)}"  />
      <billing-order-dropdown-button v-if="index == 0" class="dropdown-button margin-top" @action-change="onActionChange" @on-main-click="onDropdownMainButton" :rowsSelected="JtDataTable.selected.length" />
      <q-btn :class="'jt-data-table-button ' + button.name + '-btn'" color="secondary" class="margin-top"
        :disable="!filterButton(button, null, false)" v-if="filterButton(button, null, true)"
        @click="actionButtonValidate(button)">
        <q-icon v-if="button.nmIcon" :name="button.nmIcon" size="18px" class="position-icon-filter" />
        {{ button.label }}
      </q-btn>
    </span>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTableButtons } from 'jtech-webcomps'
import BillingOrderDropdownButton from '../dropdown-button/BillingOrderDropdownButton.vue'
import BillingOrderDropdownNewButton from '../dropdown-button/BillingOrderDropdownNewButton.vue'
@Component({
  props: {
    buttonsFilter: {
      type: Function
    }
  },
  components: {
    JtDataTableButtons, BillingOrderDropdownButton, BillingOrderDropdownNewButton
  },
  mixins: [JtDataTableButtons]
})
class BillingOrderJtDataTableButtons extends Vue {
  onActionChange (button) {
    this.$emit('action-change', button)
  }

  onDropdownMainButton (button) {
    this.actionButton(button, {}, this)
  }

  filterButtons (button) {
    return button.filter((button) => button.name.indexOf('btNovo') < 0)
  }

  filterButtonsNew (button) {
    return button.filter((button) => button.name.indexOf('btNovo') != -1)
  }
}
export default BillingOrderJtDataTableButtons
</script>
<style lang="stylus" scoped>
  @import '~quasar-variables';

  .dropdown-button {
    margin-left: 7px;
    margin-right: 7px;
  }

  .margin-top {
    margin-top: 8px;
  }

  .buttons-top {
    .icInativar > button, .icInativarComposicao > button {
      margin-right: -7px;
      width: 125px;
    }

    .icAtivar > button, .icAtivarComposicao > button {
      width: 125px;
      margin-left: -7px;
    }
  }
  </style>
